import { Options } from 'ky';

import { localizePath as basePath, localizeUuid } from '@/constants/api';
import { LangID } from '@/constants/lang';

import { Api } from '../api';

abstract class ServiceLocalize {
  api: Api;

  get options(): Options {
    return {};
  }

  constructor() {
    this.api = new Api({ basePath, options: this.options });
  }

  async getLang(lang: LangID) {
    const response = await this.api.get<Record<string, string>>(
      `/${localizeUuid}/_latest/${lang}`,
    );
    return response;
  }
}

export default ServiceLocalize;
